import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { messages } from '../i18n';
import { ToolTipContentWithKeymap } from './ToolTipContentWithKeymap';
import { backspace } from '../../util/keymaps';
import VisuallyHidden from '@atlaskit/visually-hidden';
export const DeletableEmojiTooltipContent = () => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement(ToolTipContentWithKeymap, {
    description: formatMessage(messages.deleteEmojiTooltip),
    keymap: backspace
  });
};
export const DeletableEmojiTooltipContentForScreenReader = ({
  emoji
}) => {
  return /*#__PURE__*/React.createElement(VisuallyHidden, {
    id: `screenreader-emoji-${emoji.id}`
  }, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.deleteEmojiTooltipForScreenreader, {
    values: {
      shortName: emoji.shortName
    }
  })));
};